import { render } from "./search-result-total.vue?vue&type=template&id=4c2cea38&scoped=true"
import script from "./search-result-total.vue?vue&type=script&lang=js"
export * from "./search-result-total.vue?vue&type=script&lang=js"

import "./search-result-total.vue?vue&type=style&index=0&id=4c2cea38&lang=scss&scoped=true"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4c2cea38"]])

export default __exports__